import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import { Table } from "react-bootstrap";
import TextField from '@material-ui/core/TextField';
import ClearOrder from "../components/modal/ClearOrder";

import ttDesignLiner from "../images/ttDesignLiner.png";
import tfDesignLiner from "../images/tfDesignLiner.png";
import ShapeCreationRadio from "../components/shapeCreationRadio/ShapeCreationRadio";

export default class MultipleDesignerLinerSelection extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      addButtonActive: false,
      openClear: false,
      showClear: true,
      accountNumber: localStorage.getItem("accountNumber"),
      isBilateral: false,
      isSubmit: false,
      isLoaded: false,
      patientInfo: [],
      shapeCreations: [],
      designLinerTypes: [],
      designLinerSuspensions: [],
      designLinerFabrics: [],
      linerDesignOptions: [],
      UOMs: [],
      linerCreationTypes: [],
      linerColors: [],
      designLinerPartNumbers: [],
      designTechnicianContacts: [],
      amputationLevels: [],
      footDirections: [],
      duplicateLinerSerialNumbers: [],
      formState: {
        designLinerSuspension: new FieldState(true, null),
        shapeCreation: new FieldState(true, null),
        UOM: new FieldState(false, null),
        patientId: new FieldState(true, null),
        amputationLevel: new FieldState(true),
        footDirection: new FieldState(true, null),
        designLinerFabric: new FieldState(true, null),
        notes: new FieldState(false, null),
        linerCreationType: new FieldState(true, null),
        designLinerType: new FieldState(true, null),
        linerColor: new FieldState(true, null),
        baseLinerThickness: new FieldState(false, null),
        distalThickness: new FieldState(false, null),
        proximalThickness: new FieldState(false, null),
        posteriorThickness: new FieldState(false, null),
        medialThickness: new FieldState(false, null),
        linerDesignOption: new FieldState(true, {}),
        highestCircumference: new FieldState(false, null),
        lengthToHighest: new FieldState(false, null),
        residualLength: new FieldState(false, null),
        totalLength: new FieldState(false, null),
        partNumber: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        cadFile: new FieldState(false),
        duplicateLinerPartNumber: new FieldState(false, ""),
        newLinerPartNumber: new FieldState(false, ""),
        linerQuantityDuplicate: new FieldState(false, 0),
        linerQuantityNew: new FieldState(false, 0),
        designTechnicianContact: new FieldState(true, null),
        currentLiners: [],
      },
    };

    this.selectedValue = "0"

    this.buffId = 524
    this.taupeId = 528
    this.grayId = 527

    this.selectId = 523

    this.TTid = 3
    this.symesId = 4
    this.TFid = 5
    this.kneeDisarticId = 6
    this.creationTypeNewId = 531
    this.creationTypeDuplicateId = 532;

    this.fromCADFileId = 101;
    this.fromCastId = 98;

    this.cushionId = 515
    this.lockingId = 516
    this.duoId = 517
    this.maxId = 522

    this.SideLeftId = 11;
    this.SideRightId = 12;
    this.maxNotesLength = 250;
    
    this.linerQuantityNewName = "linerQuantityNew"
    this.linerQuantityDuplicateName = "linerQuantityDuplicate";

    this.addLinerFromPartNumber = this.addLinerFromPartNumber.bind(this);
    this.addFromSerialNumber = this.addFromSerialNumber.bind(this);
    this.loadCart = this.loadCart.bind(this);

    this.onFileChange = this.onFileChange.bind(this);
    this.onCheckChange = this.onCheckChange.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.addFile = this.addFile.bind(this);
  }

  async setServerLinerQuantity(partNumber, quantity, formIndex) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    const fromDuplicate = this.state.formState.linerCreationType.value === this.creationTypeDuplicateId;
    this.setState({isLoaded: false});
    axios.post(
      Config.baseApiUrl + "designLinerQuantity/" + this.props.formTypeId + '?fromDuplicate=' + fromDuplicate + '&formIndex=' + formIndex, {
      partnumber: partNumber,
      quantity: quantity
    },
      config
    ).then(response => {
      if (response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    })
    .finally(() => {
      this.setState({isLoaded: true})
    });
  }

  setLocalLinerQuantity(partNumber, formIndex, quantity) {
    var formState = this.state.formState
    var liners = formState.currentLiners;
    liners = this.state.formState.currentLiners.map((liner) => {
      if (liner.partNumber === partNumber && liner.formIndex === formIndex) {
        liner.quantity = quantity;
      }

      return liner;
    });

    formState.currentLiners = liners;
    this.setState({
      formState: formState
    });
  }

  addLinerFromPartNumber() {
    var formState = this.state.formState;

    let partNumber = formState.newLinerPartNumber.value;
    let quantity = formState.linerQuantityNew.value;

    if (partNumber === "" || partNumber == null || quantity <= 0) {
      return;
    }
    if (!this.areNotesLessThanMaxLength()) {
      CreateNotification(`Notes field has exceeded character limit of ${this.maxNotesLength}`, "error");
      return null;
    }

    this.state.addButtonActive = true;
    this.addLinerRequest(partNumber, quantity);

    formState.newLinerPartNumber.value = "";
    formState.linerQuantityNew.value = 0;

    this.setState({
      formState: formState
    });
  }

  addFromSerialNumber() {
    var formState = this.state.formState;

    let partNumber = formState.duplicateLinerPartNumber.value;
    let quantity = formState.linerQuantityDuplicate.value;

    if (partNumber === "" || partNumber == null || quantity <= 0) {
      return;
    }
    
    let snExistsInOtherForm = false;
    let otherSerialNumber = null;
    if (this.props.isBilateral) {
      const otherFormId = this.props.formIndex === 1 ? 0 : 1;
      otherSerialNumber = this.state.duplicateLinerSerialNumbers.filter(dlsn => dlsn.formIndex === otherFormId);
      if (otherSerialNumber.length !== 0 && partNumber === otherSerialNumber[0].serialNumber) {
        snExistsInOtherForm = true;
      }
    }
    if (snExistsInOtherForm) {
      CreateNotification(`This serial number ${otherSerialNumber[0].serialNumber} is already used on form ${otherSerialNumber[0].formIndex + 1}`, "error");
      return;
    }
    if (!this.areNotesLessThanMaxLength()) {
      CreateNotification(`Notes field has exceeded character limit of ${this.maxNotesLength}`, "error");
      return null;
    }

    this.state.addButtonActive = true;
    this.addLinerRequest(partNumber, quantity, true);

    formState.linerQuantityDuplicate.value = 0;

    this.setState({
      formState: formState
    });
  }

  async addLinerRequest(partNumber, quantity, fromSerial = false) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    if (!fromSerial) {
      let formState = this.state.formState;
      const currentFootDirection = formState.footDirection.value;
      formState.footDirection.value = currentFootDirection;

      this.setState({
        formState: formState
      });
    }

    this.saveData()
      .then(() => {
        axios.post(
          Config.baseApiUrl + "designLiner/" + this.props.formTypeId + '?fromSerial=' + fromSerial + '&formIndex=' + this.props.formIndex,
          {
            partnumber: partNumber,
            quantity: quantity,
          },
          config
        ).then(response => {
          if (response.data.success) {
            this.loadCart();
          } else {
            CreateNotification(response.data.message, "error");
          }
        })
      }).finally(() => {
        this.setState({ addButtonActive: false })
      });
  }

  async loadCart() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    var saveLiners = (cartData) => {
      let liners = cartData.map((item) => {
        if (item === null) {
          return null;
        }
        
        return {
          name: item.name,
          partNumber: item.partNumber,
          quantity: item.quantity,
          formIndex: item.formIndex,
          serialNumber: item.serialNumber,
          footSide: item.footSide,
        };
      });

      let linersToDisplay = []
      if (this.state.formState.linerCreationType.value === this.creationTypeNewId) {
        const groupedLiners = Object.groupBy(liners, ({formIndex}) => {
            return formIndex
        });
        const groupedList = Object.entries(groupedLiners).map(([key, values]) => ({
          key,
          values
        }));
        for (let i = 0; i < groupedList.length; i++) {
          groupedList[i].values.forEach(l => {
            let liner = l;
            let duplicateDesignLinerPartNumber = ""
            switch (l.partNumber) {
              case "ALL-DES-OT":
              case "ALL-DES-EO":
                duplicateDesignLinerPartNumber = "ALL-DES-DP";
                break;
              case "ALC-DES-OT":
              case "ALC-DES-EO":
                duplicateDesignLinerPartNumber = "ALC-DES-DP";
                break;
              case "ADC-DES-OT":
              case "ADC-DES-EO":
                duplicateDesignLinerPartNumber = "ADC-DES-DP";
                break;
              default:
                break;
            }
            if (duplicateDesignLinerPartNumber === "") {
              return;
            }
            const duplicateQuantity = groupedList[i].values.find(l => l.partNumber === duplicateDesignLinerPartNumber)?.quantity ?? 0;
            liner.quantity += duplicateQuantity;
            linersToDisplay.push(liner)
          })
        }
      } else {
        linersToDisplay = liners.filter(l => l.partNumber !== "DES-SETUP");
      }

      var formState = this.state.formState;
      formState.currentLiners = linersToDisplay;
      
      this.setState({
        formState: formState
      });
    }
    saveLiners = saveLiners.bind(this);

    if (this.props.isBilateral) {
      await axios.all([axios.get(
        Config.baseApiUrl + "cart/" + this.props.formTypeId + '?formIndex=0',
        config
      ),
      axios.get(
        Config.baseApiUrl + "cart/" + this.props.formTypeId + '?formIndex=1',
        config
      )]).then(async (response) => {
        let responses = []
        responses = response[0].data.concat(response[1].data);
        saveLiners(responses);
        await this.props.loadCart(true);
        this.setState({isLoaded: true})
      }).catch(error => {
        console.log(error)
      });
    } else {
      await axios.get(
        Config.baseApiUrl + "cart/" + this.props.formTypeId,
        config
      ).then(async (response) => {
        saveLiners(response.data);
        await this.props.loadCart(true);
        this.setState({isLoaded: true})

      }).catch(error => {
        console.log(error)
      });
    }

  }

  onInputChange(e, id) {
    if ((e.target.value < 0) && (id === this.linerQuantityNewName || id === this.linerQuantityDuplicateName)) {
      return;
    }
    let formState = this.state.formState;
    formState[id].value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    let header = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    }

    this.setState({
      designLinerTypes: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "designLinerType" },
          }
        )
      ).data,
      designLinerSuspensions: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "designLinerSuspension" },
          }
        )
      ).data,
      shapeCreations: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "shapeCreation" },
          }
        )
      ).data.filter(sc => sc.displayName !== "OMEGA/Tracer File"),
      designLinerFabrics: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "designLinerFabric" },
          }
        )
      ).data,
      linerColors: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerColor" },
          }
        )
      ).data,
      linerDesignOptions: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "linerDesignOption" },
          }
        )
      ).data,
      UOMs: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          { params: { fieldName: "UOM" } }
        )
      ).data,
      linerCreationTypes: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          { params: { fieldName: "linerCreationType" } }
        )
      ).data,
      designTechnicianContacts: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          { params: { fieldName: "designTechnicianContact" } }
        )
      ).data,
      designLinerPartNumbers: (
        await axios.get(
          Config.baseApiUrl + "designLiner/", {
          headers: header,
        })
      ).data,
      amputationLevels: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "amputationLevel" },
          }
        )
      ).data,
      footDirections: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          {
            params: { fieldName: "footDirection" },
          }
        )
      ).data,
      patientInfo: (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId, {
          headers: header,
        })
      ).data,
    });

    let config = {
      headers: header,
      params: {
        fieldNames: [
          "UOM",
          "amputationLevel",
          "footDirection",
          "shapeCreation",
          "notes",
          "designLinerSuspension",
          "designLinerType",
          "designLinerFabric",
          "linerColor",
          "baseLinerThickness",
          "distalThickness",
          "proximalThickness",
          "posteriorThickness",
          "medialThickness",
          "linerCreationType",
          "highestCircumference",
          "lengthToHighest",
          "residualLength",
          "totalLength",
          "linerDesignOption",
          "designTechnicianContact",
          "duplicateLinerPartNumber",
        ],
      },
    };

    let response = null
    if (!this.props.isBilateral) {
      response = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
    } else {
      response = await axios.get(
        Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=" + this.props.formIndex,
        config
      );
    }

    let formIndexOneResponse = null
    if (this.props.isBilateral && this.props.formIndex === 1) {
      config.params.fieldNames = ["footDirection"]
      formIndexOneResponse = await axios.get(
        Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=0",
        config
      );
    }

    if (this.props.isBilateral) {
      let duplicateLinerPNForBilateralConfig = {
        headers: header,
        params: {
          fieldNames: [
            "duplicateLinerPartNumber",
          ],
        },
      };

      const duplicateLinerPNForBilateralData = await axios.all([
        axios.get(
          Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=0",
          duplicateLinerPNForBilateralConfig
        ),
        axios.get(
          Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=1",
          duplicateLinerPNForBilateralConfig
        )]
      );

      let serialNumbers = []
      duplicateLinerPNForBilateralData.forEach(dlpbd => {
        const data = dlpbd.data[0];
        serialNumbers.push({ formIndex: data.formIndex, serialNumber: data.stringData })
      })

      this.setState({ duplicateLinerSerialNumbers: serialNumbers })
    }

    const { data } = response;
    
    let formState = this.state.formState;
    formState.patientId.value = this.state.patientInfo.patientId;
    if (!this.props.isBilateral || this.props.formIndex === 0) {
      formState.footDirection.value = data.find(
        (fi) => fi.fieldName === "footDirection"
      ).fieldOptionId;
    } else {
      const formIndexOneData = formIndexOneResponse.data;
      const firstFormFootDirection = formIndexOneData.find(
        (fi) => fi.fieldName === "footDirection"
      ).fieldOptionId;

      if (firstFormFootDirection === 11) {
        formState.footDirection.value = 12;
      } else {
        formState.footDirection.value = 11;
      }
    }
    formState.amputationLevel.value = data.find(
      (fi) => fi.fieldName === "amputationLevel"
    ).fieldOptionId;
    formState.UOM.value = data.find(
      (fi) => fi.fieldName === "UOM"
    ).fieldOptionId;
    formState.shapeCreation.value = data.find(
      (fi) => fi.fieldName === "shapeCreation"
    ).fieldOptionId;
    formState.notes.value = data.find(
      (fi) => fi.fieldName === "notes"
    ).stringData;
    formState.designLinerSuspension.value = data.find(
      (fi) => fi.fieldName === "designLinerSuspension"
    ).fieldOptionId;
    formState.designLinerType.value = data.find(
      (fi) => fi.fieldName === "designLinerType"
    ).fieldOptionId;
    formState.designLinerFabric.value = data.find(
      (fi) => fi.fieldName === "designLinerFabric"
    ).fieldOptionId;
    formState.linerColor.value = data.find(
      (fi) => fi.fieldName === "linerColor"
    ).fieldOptionId;
    formState.baseLinerThickness.value = data.find(
      (fi) => fi.fieldName === "baseLinerThickness"
    ).numericData;
    formState.distalThickness.value = data.find(
      (fi) => fi.fieldName === "distalThickness"
    ).numericData;
    formState.proximalThickness.value = data.find(
      (fi) => fi.fieldName === "proximalThickness"
    ).numericData;
    formState.posteriorThickness.value = data.find(
      (fi) => fi.fieldName === "posteriorThickness"
    ).numericData;
    formState.medialThickness.value = data.find(
      (fi) => fi.fieldName === "medialThickness"
    ).numericData;
    formState.linerCreationType.value = data.find(
      (fi) => fi.fieldName === "linerCreationType"
    ).fieldOptionId ?? this.creationTypeNewId;
    formState.highestCircumference.value = data.find(
      (fi) => fi.fieldName === "highestCircumference" && fi.fieldOptionId === formState.amputationLevel.value
    )?.stringData ?? null;
    formState.lengthToHighest.value = data.find(
      (fi) => fi.fieldName === "lengthToHighest" && fi.fieldOptionId === formState.amputationLevel.value
    )?.stringData ?? null;
    formState.residualLength.value = data.find(
      (fi) => fi.fieldName === "residualLength" && fi.fieldOptionId === formState.amputationLevel.value
    )?.stringData ?? null;
    formState.totalLength.value = data.find(
      (fi) => fi.fieldName === "totalLength" && fi.fieldOptionId === formState.amputationLevel.value
    )?.stringData ?? null;
    for (let i = 0; i < this.state.linerDesignOptions.length; i++) {
      let fieldOptionId = this.state.linerDesignOptions[i].id;
      let fieldInput = data.find(
        (fi) =>
          fi.fieldName === "linerDesignOption" &&
          fi.fieldOptionId === fieldOptionId
      );
      if (fieldInput !== undefined) {
        formState.linerDesignOption.value[fieldOptionId] =
          fieldInput.booleanData;
      } else {
        formState.linerDesignOption.value[fieldOptionId] = false;
      }
    };
    formState.designTechnicianContact.value = data.find(
      (fi) => fi.fieldName === "designTechnicianContact"
    ).fieldOptionId;
    formState.duplicateLinerPartNumber.value = data.find(
      (fi) => fi.fieldName === "duplicateLinerPartNumber"
    ).stringData;

    const cadFile = (
      await axios.get(
        Config.baseApiUrl + "cadFiles/" + this.props.formTypeId + '?formIndex=' + this.props.formIndex, {
        headers: header
      })
    ).data;
    formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

    this.setState({ formState: formState })
    await this.loadCart();
    this.updateLinerInformationRequiredFields()
    this.getFormSteps();
    this.setState({ isLoaded: true });
  }

  saveData() {

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    this.saveCadFile(config);

    let data = [];

    data.push({
      fieldName: "UOM",
      fieldOptionId: this.state.formState.UOM.value,
    });
    data.push({
      fieldName: "shapeCreation",
      fieldOptionId: this.state.formState.shapeCreation.value,
    });
    data.push({
      fieldName: "linerCreationType",
      fieldOptionId: this.state.formState.linerCreationType.value,
    });
    data.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });
    data.push({
      fieldName: "designLinerSuspension",
      fieldOptionId: this.state.formState.designLinerSuspension.value,
    });
    data.push({
      fieldName: "designLinerType",
      fieldOptionId: this.state.formState.designLinerType.value,
    });
    data.push({
      fieldName: "designLinerFabric",
      fieldOptionId: this.state.formState.designLinerFabric.value,
    });
    data.push({
      fieldName: "linerColor",
      fieldOptionId: this.state.formState.linerColor.value,
    });
    data.push({
      fieldName: "baseLinerThickness",
      numericData: this.state.formState.baseLinerThickness.value,
    });
    data.push({
      fieldName: "distalThickness",
      numericData: this.state.formState.distalThickness.value,
    });
    data.push({
      fieldName: "proximalThickness",
      numericData: this.state.formState.proximalThickness.value,
    });
    data.push({
      fieldName: "posteriorThickness",
      numericData: this.state.formState.posteriorThickness.value,
    });
    data.push({
      fieldName: "medialThickness",
      numericData: this.state.formState.medialThickness.value,
    });
    data.push({
      fieldName: "highestCircumference",
      stringData: this.state.formState.highestCircumference.value,
      fieldOptionId: this.state.formState.amputationLevel.value,
    });
    data.push({
      fieldName: "residualLength",
      stringData: this.state.formState.residualLength.value,
      fieldOptionId: this.state.formState.amputationLevel.value,
    });
    data.push({
      fieldName: "totalLength",
      stringData: this.state.formState.totalLength.value,
      fieldOptionId: this.state.formState.amputationLevel.value,
    });
    data.push({
      fieldName: "lengthToHighest",
      stringData: this.state.formState.lengthToHighest.value,
      fieldOptionId: this.state.formState.amputationLevel.value,
    });
    data.push({
      fieldName: "designTechnicianContact",
      fieldOptionId: this.state.formState.designTechnicianContact.value,
    });
    data.push({
      fieldName: "duplicateLinerPartNumber",
      stringData: this.state.formState.duplicateLinerPartNumber.value,
    });
    data.push({
      fieldName: "amputationLevel",
      fieldOptionId: this.state.formState.amputationLevel.value,
    });
    data.push({
      fieldName: "footDirection",
      fieldOptionId: this.state.formState.footDirection.value,
    })
    for (let i = 0; i < this.state.linerDesignOptions.length; i++) {
      let fieldOptionId = this.state.linerDesignOptions[i].id;

      data.push({
        fieldName: "linerDesignOption",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.linerDesignOption.value[fieldOptionId],
        dataIndex: i,
      });
    }

    let patientData = {
      patientId: this.state.formState.patientId.value,
      isBilateral: this.props.isBilateral,
      fieldInputs: [],
    };

    if (!this.props.isBilateral) {
      return axios.all([axios.post(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        data,
        config
      ),
      axios.post(
        Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
        patientData,
        config
      )]).then((response) => {
        return response[0];
      })
    } else {
      return axios.all([axios.post(
        Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=" + this.props.formIndex,
        data,
        config
      ),
      axios.post(
        Config.baseApiUrl + "patientInfo1s?id=" + this.props.formTypeId + "&formIndex=" + this.props.formIndex,
        patientData,
        config
      )]).then((response) => {
        return response[0];
      });
    }
  }

  saveCadFile(config) {
    if (this.state.formState.cadFile.value !== "" && this.isFromCADFileSelected()) {
      const formData = new FormData();

      formData.append("cadFile", this.state.formState.cadFile.value);

      axios.post(
        Config.baseApiUrl + "cadFiles/" + this.props.formTypeId + '?formIndex=' + this.props.formIndex,
        formData,
        config
      )
    }

    if (this.state.formState.cadFileName.value !== "" && !this.isFromCADFileSelected()) {
      const formData = new FormData();

      formData.append("cadFile", null,);

      axios.put(
        Config.baseApiUrl + "cadFiles/" + this.props.formTypeId + '?formIndex=' + this.props.formIndex,
        formData,
        config
      )
    }
  }

  handleClickClearOpen = () => {
    this.setState({ openClear: true })
  };

  handleCloseClear = () => {
    this.setState({ openClear: false })
    this.setState({ showClear: true })
  };

  setShowClear = (value) => {
    this.setState({ showClear: value })
  }

  handleClearBack = () => {
      this.props.setActiveOuterStep(0);
      window.location.reload()
  };

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  onRadioChange(e, field) {
    super.onRadioChange(e, field);

    let formState = this.state.formState;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  removeFile() {
    this.state.formState.cadFile.isRequired = false;
    this.state.formState.cadFileName.isRequired = false;
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  addFile() {
    if (this.state.formState.cadFileName.value !== "") {
      this.state.formState.cadFileName.isRequired = false;
    } else {
      this.state.formState.cadFileName.isRequired = true;
    }
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });

    this.loadCart();
  }

  onFileChange(e) {
    const file = e.target.files[0];
    if (file === undefined) {
      return null;
    }
    if (file.size >= 8000000) {
      CreateNotification("File type size must be less than 8mb.", "error");
      return null;
    }
    let formState = this.state.formState;
    const previouslyUploadedFileName = formState.cadFileName.value;
    formState.cadFileName.value = "";
    const newFileName = this.renameFile(file);
    if (newFileName !== null) {
      formState.cadFile.value = newFileName;
      formState.cadFile.isRequired = this.isFromCADFileSelected();
    } else {
      formState.cadFileName.value = previouslyUploadedFileName;
    }
    this.setState({ formState: formState, hasDataChanged: true });
  }

  renameFile(file) {
    const oldName = file?.name;
    if (oldName === undefined) {
      return null;
    }
    const oldFileType = oldName.split(".").slice(-1)[0];
    if (this.validFileTypes(oldFileType)) {
      const newName = Date.now() + "_" + (this.state?.patientInfo?.patientId ?? "attachment") + "." + oldFileType;
      this.state.formState.cadFileName.value = newName;
      return new File([file], newName);
    } else {
      CreateNotification("File type must be .stl, .obj or .aop", "error");
      return null;
    }
  }

  validFileTypes(oldFileType) {
    return (oldFileType === 'stl' || oldFileType === 'obj' || oldFileType === 'aop')
  }

  isFromCADFileSelected() {
    return this.state.formState.shapeCreation.value === this.fromCADFileId;
  }

  setValidationFields(value) {
    let formState = this.state.formState;
    if (formState.linerCreationType.value !== null && formState.linerCreationType.value !== this.creationTypeNewId) {
      formState.UOM.isRequired = value;
      formState.designLinerSuspension.isRequired = value;
      formState.shapeCreation.isRequired = value;
      formState.designLinerFabric.isRequired = value;
      formState.amputationLevel.isRequired = value;
      formState.designLinerType.isRequired = value;
      formState.linerColor.isRequired = value;
      formState.baseLinerThickness.isRequired = value;
      formState.distalThickness.isRequired = value;
      formState.proximalThickness.isRequired = value;
      formState.posteriorThickness.isRequired = value;
      formState.medialThickness.isRequired = value;
      formState.linerDesignOption.isRequired = value;
      formState.highestCircumference.isRequired = value;
      formState.lengthToHighest.isRequired = value;
      formState.residualLength.isRequired = value;
      formState.totalLength.isRequired = value;
      formState.partNumber.isRequired = value;
      formState.cadFileName.isRequired = value;
      formState.castShippedSeparately.isRequired = value;
      formState.cadFile.isRequired = value;
      formState.duplicateLinerPartNumber.isRequired = value;
      formState.newLinerPartNumber.isRequired = value;
      formState.linerQuantityDuplicate.isRequired = value;
      formState.linerQuantityNew.isRequired = value;
      formState.designTechnicianContact.isRequired = value;

      this.setState({ formState: formState, hasDataChanged: true });
    }
  }

  updateLinerInformationRequiredFields() {
    let formState = this.state.formState
    if (this.state.formState.designLinerSuspension.value === this.duoId) {
      formState.designLinerType.isRequired = false
      formState.designLinerFabric.isRequired = false
      formState.linerColor.isRequired = false
      formState.designLinerType.value = null
      formState.designLinerFabric.value = null
      formState.linerColor.value = null
    } else if (this.state.formState.designLinerSuspension.value !== this.duoId) {
      formState.designLinerType.isRequired = true
      formState.designLinerFabric.isRequired = true
      formState.linerColor.isRequired = true
    }
    this.setState({
      formState: formState
    })
  }

  resetStartingThicknesses() {
    let formState = this.state.formState
    formState.baseLinerThickness.value = null
    formState.distalThickness.value = null
    formState.proximalThickness.value = null
    formState.posteriorThickness.value = null
    formState.medialThickness.value = null
    this.setState({
      formState: formState
    })
  }

  getFormSteps() {
    let itemsToHide = []
    if (this.state.formState.linerCreationType.value !== this.creationTypeNewId) {
      itemsToHide.push(2);
      itemsToHide.push(3);
      itemsToHide.push(4);
      itemsToHide.push(5);
      itemsToHide.push(6);
      itemsToHide.push(7);
      itemsToHide.push(8);
      itemsToHide.push(10);
    }
    if (this.state.formState.designLinerSuspension.value !== null && this.state.formState.designLinerSuspension.value === this.duoId) {
      itemsToHide.push(5);
      itemsToHide.push(6);
      itemsToHide.push(7);
    }
    this.props.getFormSteps(itemsToHide);
  }

  resetRequestedStartingThickness() {
    let formState = this.state.formState;
    formState.highestCircumference.value = ""
    formState.residualLength.value = ""
    formState.totalLength.value = ""
    formState.lengthToHighest.value = ""
    formState.baseLinerThickness.value = ""
    formState.distalThickness.value = ""
    formState.proximalThickness.value = ""
    formState.posteriorThickness.value = ""
    formState.medialThickness.value = ""
    this.setState({
      formState: formState, stateHasChanged: true
    });
  }

  async updateFootDirection(e) {
    this.onRadioChange(e, "footDirection");
    if (!this.areNotesLessThanMaxLength()) {
      CreateNotification(`Notes field has exceeded character limit of ${this.maxNotesLength}`, "error");
      return null;
    }
    await this.saveData()
    this.loadCart();
  }
  
  areProductsAddedToForm() {
    let totalNoOfLiners = 0;
    if (this.state.formState.currentLiners !== null) {
      this.state.formState.currentLiners.forEach(cl => {
        if (this.props.formIndex === cl.formIndex) {
          totalNoOfLiners += parseInt(cl.quantity);
        }
      })
    }
    return totalNoOfLiners > 0;
  }

  areNotesLessThanMaxLength() {
    let isLessThanLimit = true;
    const notesLength = this.state.formState.notes?.value?.length;
    if (notesLength > this.maxNotesLength) {
      isLessThanLimit = false;
    }
    return isLessThanLimit;
  }

  isPatientInformationComplete() {
    return (this.state.formState.shapeCreation.value !== null &&
      this.state.formState.patientId.value !== null &&
      this.state.formState.patientId.value !== "" &&
      this.state.formState.footDirection.value !== "" &&
      this.state.formState.footDirection.value !== null &&
      (this.state.formState.linerCreationType.value === this.creationTypeNewId &&
        this.state.formState.amputationLevel.value !== null && 
        this.state.formState.amputationLevel.value !== ""))
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    
    const defaultFootSide = this.props.isBilateral ? this.props.formIndex === 0 ? this.SideLeftId : this.SideRightId : null;
    this.state.formState.footDirection.value = this.state.formState.footDirection.value ?? defaultFootSide;
    
    const defaultFootsideOptions = this.state.footDirections.filter(fd => this.props.isBilateral && fd.id === defaultFootSide)
    if (this.props.isBilateral) {
      this.state.footDirections = defaultFootsideOptions;
    }
    
    let validSuspensions = this.state.designLinerSuspensions;

    let validColorOptions = this.state.formState.amputationLevel.value !== this.TTid && this.state.formState.amputationLevel.value !== this.symesId ? this.state.linerColors
      .filter(co => co.id === this.buffId || co.id === this.taupeId || co.id === this.grayId) : this.state.linerColors;

    validColorOptions =
      this.state.formState.designLinerFabric.value === this.selectId ?
        validColorOptions.filter(co => co.id === this.taupeId || co.id === this.grayId) :
        this.state.formState.designLinerFabric.value === this.maxId ?
          validColorOptions.filter(co => co.id === this.buffId) :
          validColorOptions.filter(co => co.id !== this.taupeId && co.id !== this.grayId);

    switch (this.state.formState.designLinerSuspension.value) {
      case this.cushionId: this.state.formState.newLinerPartNumber.value = this.state.designLinerPartNumbers?.find(dpo => dpo.partNumber === 'ALC-DES-EO')?.partNumber
        break;
      case this.lockingId: this.state.formState.newLinerPartNumber.value = this.state.designLinerPartNumbers?.find(dpo => dpo.partNumber === 'ALL-DES-EO')?.partNumber
        break;
      case this.duoId: this.state.formState.newLinerPartNumber.value = this.state.designLinerPartNumbers?.find(dpo => dpo.partNumber === 'ADC-DES-EO')?.partNumber
        break;
      default: this.state.formState.newLinerPartNumber.value = null
    }

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => { e.preventDefault() }}>
            <div className="radioGroup m-0"></div>

            {this.state.isBilateral ?
              <div className="fieldBorder"><h4 className="headLable">
                <b>{this.props.formIndex === 0 ? "First Liner" : "Second Liner"}</b>
              </h4>
              </div> :
              <></>
            }

            {this.state.formState.linerCreationType.value !== null && this.state.formState.linerCreationType.value !== this.creationTypeNewId ?
              <>
                <div className="fieldBorder">
                  <h4 className="headLable"><b>Patient Information</b></h4>
                  <div>
                    <InputTextField
                      label="Patient ID"
                      variant="outlined"
                      placeholder="Patient ID"
                      type="text"
                      disabled={this.props.isBilateral && this.props.formIndex === 1 ||
                        this.areProductsAddedToForm()}
                      required={this.state.formState.patientId.isRequired}
                      error={this.handleError("patientId") && this.state.isSubmit}
                      value={this.state.formState.patientId.value}
                      onChange={(e) => {
                        this.props.setActiveInnerStep(12);
                        this.onInputChange(e, "patientId");
                      }}
                    />
                  </div>

                  <MuiRadio
                    disabled={this.areProductsAddedToForm()}
                    options={this.state.footDirections}
                    label="Amputation Side"
                    required={true}
                    defaultValue={this.state.formState.footDirection.value}
                    error={this.handleError("footDirection") && this.state.isSubmit}
                    onChange={(e) => {
                      this.props.setActiveInnerStep(12);
                      this.updateFootDirection(e);
                    }}
                  />
                </div>

                {this.state.formState.patientId.value !== null && this.state.formState.patientId.value !== "" ?
                  <div className="fieldBorder">
                    <h4 className="headLable"></h4>
                    <div className="fieldWrapper">
                      <InputTextField
                        disabled={this.areProductsAddedToForm()}
                        label="Serial Number"
                        variant="outlined"
                        placeholder=""
                        type="text"
                        width="384px"
                        required={false}
                        value={this.state.formState.duplicateLinerPartNumber?.value ?? ""}
                        onChange={(e) => {
                          this.onInputChange(e, "duplicateLinerPartNumber")
                          this.props.setActiveInnerStep(9)
                        }}
                      />
                      <InputTextField
                        disabled={this.areProductsAddedToForm()}
                        label="Duplicate Design Liner Quantity"
                        variant="outlined"
                        placeholder=""
                        type="number"
                        width="384px"
                        required={false}
                        value={this.state.formState.linerQuantityDuplicate.value}
                        onChange={(e) => {
                          this.onInputChange(e, this.linerQuantityDuplicateName)
                          this.props.setActiveInnerStep(9)
                        }}
                      />
                      {!this.areProductsAddedToForm() ?
                        <div style={{ paddingTop: '20px' }}>
                          <SecondaryButton
                            glow={(Number.parseInt(this.state.formState.linerQuantityDuplicate.value) !== 0 && 
                              this.state.formState.linerQuantityDuplicate.value !== "" &&
                              this.state.formState.duplicateLinerPartNumber?.value !== null &&
                              this.state.formState.duplicateLinerPartNumber?.value !== "") || this.state.addButtonActive ? 
                              true : false}
                              disabled={this.state.addButtonActive}
                            text="Add"
                            onClick={this.addFromSerialNumber}
                          />
                        </div> : <></>}
                    </div>
                    <div style={{ paddingTop: '20px' }}>
                      {!this.props.isBilateral ? <p>You may add <b>ONE</b> unique liner to the Cart per Order. If you would like to change your order,
                        please Clear your Order or Remove current liner from the Cart before adding a new liner.
                        If you would like to place a Bilateral Order, select "Bilateral" at the entry of the form.</p> : ""}
                    </div>
                  </div> : <></>}

              </> : <>
                <div className="fieldBorder">
                  <ShapeCreationRadio className="border-0"
                    options={this.state.shapeCreations}
                    defaultValue={this.state.formState.shapeCreation.value}
                    required={this.state.formState.shapeCreation.value}
                    error={this.handleError("shapeCreation") && this.state.isSubmit}
                    onChange={(e) => {
                      this.onRadioChange(e, "shapeCreation");
                      this.props.setActiveInnerStep(2)
                    }}
                    removeFile={this.removeFile}
                    addExistingFile={this.addFile}
                    fileChange={this.onFileChange}
                    fileName={this.state.formState.cadFileName.value}
                    showCastOption={false}
                  />
                </div>

                <div className="fieldBorder">
                  <h4 className="headLable"><b>Patient Information</b></h4>
                  <div>
                    <InputTextField
                      label="Patient ID"
                      variant="outlined"
                      placeholder="Patient ID"
                      type="text"
                      disabled={this.props.isBilateral && this.props.formIndex === 1 ||
                        this.areProductsAddedToForm()}
                      required={this.state.formState.patientId.isRequired}
                      error={this.handleError("patientId") && this.state.isSubmit}
                      value={this.state.formState.patientId.value}
                      onChange={(e) => {
                        this.props.setActiveInnerStep(12);
                        this.onInputChange(e, "patientId");
                      }}
                    />
                  </div>

                  <MuiRadio
                    disabled={this.areProductsAddedToForm()}
                    options={this.state.amputationLevels}
                    label="Amputation Level"
                    required={true}
                    defaultValue={this.state.formState.amputationLevel.value}
                    error={
                      this.handleError("amputationLevel") && this.state.isSubmit
                    }
                    onChange={(e) => {
                      this.resetRequestedStartingThickness();
                      this.props.setActiveInnerStep(12);
                      this.onRadioChange(e, "amputationLevel");
                    }}
                  />

                  <MuiRadio
                    disabled={this.areProductsAddedToForm()}
                    options={this.state.footDirections}
                    label="Amputation Side"
                    required={true}
                    defaultValue={this.state.formState.footDirection.value}
                    error={this.handleError("footDirection") && this.state.isSubmit}
                    onChange={(e) => {
                      this.props.setActiveInnerStep(12);
                      this.updateFootDirection(e);
                    }}
                  />
                </div>

                {this.isPatientInformationComplete() ?
                  <div className="fieldBorder">
                    <div className="designLiner">
                      <MuiRadio
                        options={this.state.UOMs}
                        defaultValue={this.state.formState.UOM.value}
                        label="Unit of Measurement"
                        required={this.state.formState.UOM.isRequired}
                        onChange={(e) => {
                          this.props.setActiveInnerStep(3)
                          this.onRadioChange(e, "UOM");
                        }}
                      />
                      <div className="measureImg">
                        {this.state.formState.amputationLevel.value === this.TTid || this.state.formState.amputationLevel.value === this.symesId ? <>
                          <img
                            src={ttDesignLiner}
                            alt="measure"
                            width="500px"
                          />
                          <div className="inputs">
                            <div className="highestCircumference_tt">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.highestCircumference.value}
                                error={
                                  this.handleError("highestCircumference") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "highestCircumference");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                            <div className="residualLength_tt">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.residualLength.value}
                                error={
                                  this.handleError("residualLength") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "residualLength");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                            <div className="totalLength_tt">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.totalLength.value}
                                error={
                                  this.handleError("totalLength") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "totalLength");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                          </div>
                        </> : <>
                          <img
                            src={tfDesignLiner}
                            alt="measure"
                            width="500px"
                          />
                          <div className="inputs">
                            <div className="highestCircumference">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.highestCircumference.value}
                                error={
                                  this.handleError("highestCircumference") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "highestCircumference");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                            <div className="residualLength">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.residualLength.value}
                                error={
                                  this.handleError("residualLength") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "residualLength");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                            <div className="lengthToHighest">
                              <InputTextField
                                placeholder=""
                                type="text"
                                value={this.state.formState.lengthToHighest.value}
                                error={
                                  this.handleError("lengthToHighest") &&
                                  this.state.isSubmit
                                }
                                onChange={(e) => {
                                  this.onInputChange(e, "lengthToHighest");
                                  this.props.setActiveInnerStep(3)
                                }}
                              />
                            </div>
                          </div>
                        </>}
                      </div>
                    </div></div>
                  : <></>}
                {this.isPatientInformationComplete() ?
                  <>
                    <div className="fieldBorder">
                      <MuiRadio
                        disabled={this.areProductsAddedToForm()}
                        options={validSuspensions}
                        defaultValue={this.state.formState.designLinerSuspension.value}
                        label="Liner Type"
                        required={this.state.formState.designLinerSuspension.isRequired}
                        checked
                        error={this.handleError("designLinerSuspension") && this.state.isSubmit}
                        onChange={(e) => {
                          this.onRadioChange(e, "designLinerSuspension");
                          this.updateLinerInformationRequiredFields()
                          this.resetStartingThicknesses()
                          this.props.setActiveInnerStep(4)
                          this.getFormSteps()
                        }}
                      />
                    </div>
                    {this.state.formState.designLinerSuspension.value !== null && this.state.formState.designLinerSuspension.value !== this.duoId ?
                      <>
                        <div className="fieldBorder">
                          <MuiRadio
                            options={this.state.designLinerTypes}
                            defaultValue={this.state.formState.designLinerType.value}
                            required={this.state.formState.designLinerType.isRequired}
                            label="Interface Material"
                            error={this.handleError("designLinerType") && this.state.isSubmit}
                            onChange={(e) => {
                              this.onRadioChange(e, "designLinerType");
                              this.props.setActiveInnerStep(5)
                            }}
                          />
                        </div>
                        {this.state.formState.designLinerType.value !== null ?
                          <div className="fieldBorder">
                            <MuiRadio
                              options={this.state.designLinerFabrics}
                              defaultValue={this.state.formState.designLinerFabric.value}
                              required={this.state.formState.designLinerFabric.isRequired}
                              label="Fabric"
                              error={this.handleError("designLinerFabric") && this.state.isSubmit}
                              onChange={(e) => {
                                this.onRadioChange(e, "designLinerFabric");
                                this.props.setActiveInnerStep(6)
                              }}
                            />
                          </div> : <></>}
                        {this.state.formState.designLinerType.value !== null && this.state.formState.designLinerFabric.value != null ?
                          <div className="fieldBorder">
                            <MuiRadio
                              options={validColorOptions}
                              defaultValue={this.state.formState.linerColor.value}
                              required={this.state.formState.linerColor.isRequired}
                              label="Fabric Color"
                              error={this.handleError("linerColor") && this.state.isSubmit}
                              onChange={(e) => {
                                this.onRadioChange(e, "linerColor");
                                this.props.setActiveInnerStep(7)
                              }}
                            />
                          </div> : <></>
                        }
                      </> : <></>
                    }
                  </> : <></>}

                {this.state.formState.designLinerSuspension.value !== null && 
                this.state.formState.patientId.value !== null && 
                this.state.formState.patientId.value !== "" ?
                  <>
                    <div className="fieldBorder">
                      <h4 className="headLable">Liner Design</h4>
                      <h4 className="headLable">Requested Starting Thickness</h4>
                      <p>Provide your desired liner thicknesses below. Minimum thickness allowed for Classic/Hybrid is 3mm, Duo is 4mm.<br />
                        Maximum thickness allowed for Classic/Hybrid/Duo is 25mm. Recommended thicknesses for each liner section are provided below.</p>
                      <div className="fieldWrapper">
                        <InputTextField
                          minValue={this.state.formState.designLinerSuspension.value === this.duoId ? 4 : 3}
                          maxValue={25}
                          label="Base Liner Thickness"
                          small="4mm to 12mm (6mm Standard)"
                          placeholder="6"
                          type="number"
                          required={this.state.formState.baseLinerThickness.isRequired}
                          value={this.state.formState.baseLinerThickness.value}
                          margin={true}
                          error={
                            this.handleError("baseLinerThickness") && this.state.isSubmit
                          }
                          onChange={(e) => {
                            this.onInputChange(e, "baseLinerThickness");
                            this.props.setActiveInnerStep(8)
                          }}
                        />
                        <InputTextField
                          minValue={this.state.formState.designLinerSuspension.value === this.duoId ? 4 : 3}
                          maxValue={25}
                          label="Distal Thickness"
                          small="4mm to 25mm (9mm Standard, 4mm for Symes)"
                          placeholder={this.state.formState.amputationLevel.value === this.symesId ? "4" : "9"}
                          type="number"
                          required={this.state.formState.distalThickness.isRequired}
                          value={this.state.formState.distalThickness.value}
                          margin={true}
                          error={
                            this.handleError("distalThickness") && this.state.isSubmit
                          }
                          onChange={(e) => {
                            this.onInputChange(e, "distalThickness");
                            this.props.setActiveInnerStep(8)
                          }}
                        />
                        <InputTextField
                          minValue={this.state.formState.designLinerSuspension.value === this.duoId ? 4 : 3}
                          maxValue={25}
                          label="Proximal Thickness"
                          small="3mm to 9mm (4mm Standard)"
                          placeholder="4"
                          type="number"
                          required={this.state.formState.proximalThickness.isRequired}
                          value={this.state.formState.proximalThickness.value}
                          margin={true}
                          error={
                            this.handleError("proximalThickness") && this.state.isSubmit
                          }
                          onChange={(e) => {
                            this.onInputChange(e, "proximalThickness");
                            this.props.setActiveInnerStep(8)
                          }}
                        />
                        {
                          this.state.formState.amputationLevel.value === this.TTid || this.state.formState.amputationLevel.value === this.symesId ?
                            <InputTextField
                              minValue={this.state.formState.designLinerSuspension.value === this.duoId ? 4 : 3}
                              maxValue={25}
                              label="Posterior Thickness"
                              small="3mm to 9mm (4mm Standard)"
                              placeholder="4"
                              type="number"
                              required={this.state.formState.posteriorThickness.isRequired}
                              value={this.state.formState.posteriorThickness.value}
                              margin={true}
                              error={
                                this.handleError("posteriorThickness") && this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "posteriorThickness");
                                this.props.setActiveInnerStep(8)
                              }}
                            /> :
                            <InputTextField
                              minValue={this.state.formState.designLinerSuspension.value === this.duoId ? 4 : 3}
                              maxValue={25}
                              label="Medial Thickness"
                              small="3mm to 9mm (4mm Standard)"
                              placeholder="4"
                              type="number"
                              required={this.state.formState.medialThickness.isRequired}
                              value={this.state.formState.medialThickness.value}
                              margin={true}
                              error={
                                this.handleError("medialThickness") && this.state.isSubmit
                              }
                              onChange={(e) => {
                                this.onInputChange(e, "medialThickness");
                                this.props.setActiveInnerStep(8)
                              }}
                            />
                        }
                      </div>

                      <MuiCheckbox
                        checkboxes={this.state.linerDesignOptions}
                        boxLabel=""
                        defaultValue={this.state.formState.linerDesignOption.value}
                        required={this.state.formState.linerDesignOption.isRequired}
                        error={
                          this.handleError("linerDesignOption") && this.state.isSubmit
                        }
                        checked
                        onChange={(e, id) => {
                          this.props.setActiveInnerStep(8)
                          this.onCheckboxChange(e, id, "linerDesignOption");
                        }}
                      />
                    </div>

                    <div className="fieldBorder">
                      <div className="fieldWrapper hidden" style={{ "marginTop": "40px" }}>
                        <InputTextField
                          disabled={this.areProductsAddedToForm()}
                          label="Selected Part Number"
                          variant="outlined"
                          placeholder=""
                          type="text"
                          width="384px"
                          required={false}
                          value={this.state.formState.newLinerPartNumber.value}
                          onChange={(e) => {
                            this.onInputChange(e, "newLinerPartNumber")
                          }}
                        />
                        <InputTextField
                          disabled={this.areProductsAddedToForm()}
                          label="New Design Liner Quantity"
                          variant="outlined"
                          placeholder=""
                          type="number"
                          width="384px"
                          required={false}
                          value={this.state.formState.linerQuantityNew.value}
                          onChange={(e) => {
                            this.onInputChange(e, this.linerQuantityNewName)
                            this.props.setActiveInnerStep(9)
                          }}
                        />
                        {!this.areProductsAddedToForm() ?
                          <div style={{ paddingTop: '20px' }}>
                            <SecondaryButton
                              glow={(Number.parseInt(this.state.formState.linerQuantityNew.value) !== 0 &&
                                this.state.formState.linerQuantityNew.value !== "" &&
                                this.state.formState.newLinerPartNumber.value !== null &&
                                this.state.formState.newLinerPartNumber.value !== "") || this.state.addButtonActive ?
                                true : false}
                              disabled={this.state.addButtonActive}
                              text="Add"
                              onClick={() => {
                                this.addLinerFromPartNumber()
                              }}
                            />
                          </div>
                          : <></>}
                      </div>
                      <div style={{ paddingTop: '20px' }}>
                        {!this.props.isBilateral ? <p>You may add <b>ONE</b> unique liner to the Cart per Order. If you would like to change your order,
                          please Clear your Order or Remove current liner from the Cart before adding a new liner. 
                          If you would like to place a Bilateral Order, select "Bilateral" at the entry of the form.</p> : ""}
                      </div>
                    </div>

                    <div className="fieldBorder">
                      <div className="fieldWrapper">
                        <MuiRadio
                          options={this.state.designTechnicianContacts}
                          defaultValue={this.state.formState.designTechnicianContact.value}
                          label="Would you like a Design Technician to contact you?"
                          required={this.state.formState.designTechnicianContact.isRequired}
                          checked
                          error={this.handleError("designTechnicianContact") && this.state.isSubmit}
                          onChange={(e) => {
                            this.onRadioChange(e, "designTechnicianContact");
                            this.props.setActiveInnerStep(10)
                          }}
                        />
                      </div>
                    </div>
                  </>
                  : <></>}
              </>}

            <div className="msgBox msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder={`Type Something here, please keep notes under ${this.maxNotesLength} characters...`}
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(11);
                }}
              />
            </div>

            {this.state.formState.currentLiners.length > 0 &&
              <div>
                <br />
                <div className="msgBox msgBoxWidth">
                  <h4 className="headLable"><b>Current Liners in Cart</b></h4>
                </div>
                <br />
                <Table className="transparent-table">
                  <thead>
                    <tr>
                      <th><b>Liner</b></th>
                      <th></th>
                      <th><b>Part Number</b></th>
                      <th><b>Quantity</b></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.formState.currentLiners.map((liner, index) => {
                      if (liner === null) {
                        return "";
                      }
                      return (
                        <tr key={index}>
                          <td lg="6" sm="1">
                            <div>{liner.name}</div>
                            <div>{liner.serialNumber !== "" ? `Serial Number: ${liner.serialNumber}` : ""}</div>
                            <div>{liner.footSide !== "" ? `Side: ${liner.footSide}` : ""}</div>
                          </td>
                          <td></td>
                          <td>
                            <div>{liner.partNumber}</div>
                          </td>
                          <td>
                            <TextField
                              type={"number"}
                              onChange={(e) => this.setLocalLinerQuantity(liner.partNumber, liner.formIndex, e.target.value)}
                              onBlur={() => this.setServerLinerQuantity(liner.partNumber, liner.quantity, liner.formIndex)}
                              value={liner.quantity}
                            />
                          </td>
                          <td><SecondaryButton
                            text="Remove"
                            onClick={() => this.setServerLinerQuantity(liner.partNumber, 0, liner.formIndex)}
                          />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            }

          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={(e) => {
                this.props.handleBack(this.props.currentIndex - 1, this.props.orderIndex)
              }}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={!this.state.isLoaded}
              onClick={async () => {
                this.setValidationFields(false)
                if (this.validateData().isValid) {
                  if (!this.areProductsAddedToForm()) {
                    CreateNotification("Cannot place Liner Order with no product added", "error");
                    return null;
                  } 
                  if (!this.areNotesLessThanMaxLength()) {
                    CreateNotification(`Notes field has exceeded character limit of ${this.maxNotesLength}`, "error");
                    return null;
                  }
                  try {
                    this.setState({ isLoaded: false });

                    const res = await this.saveData();
                    if (res.status === 204) {
                      if (this.props.isBilateral !== null && this.props.isBilateral) {
                        this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
                      } else {
                        this.props.handleNext()
                      }
                      this.setState({ isLoaded: true });
                    }
                  } catch (err) {
                    this.setState({ isLoaded: true });
                  }
                } else {
                  this.setState({
                    isSubmit: true,
                  });
                  CreateNotification(this.validateData().errorMessage, "error");
                  this.setState({ isLoaded: true });
                }
              }}
            />
          </div>

        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.state.openClear}
          handleCloseClear={this.handleCloseClear}
          showClear={this.state.showClear}
          setShowClear={this.setShowClear}
          formId={this.props.formTypeId}
          handleClearBack={this.handleClearBack}
        />
      </>
    );
  }
}
